import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { BASE_API, API_TOKEN_NAME, STORAGE_TOKEN_NAME } from '@/config/constants'

axios.defaults.baseURL = BASE_API
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem(STORAGE_TOKEN_NAME)
    if (token) {
      config.headers[API_TOKEN_NAME] = token
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

Vue.use(VueAxios, axios)
